/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrderPaymentTransactionCreate } from '../models/OrderPaymentTransactionCreate';
import type { OrderPaymentTransactionResponse } from '../models/OrderPaymentTransactionResponse';
import type { OrderPaymentTransactionUpdate } from '../models/OrderPaymentTransactionUpdate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OrderPaymentsService {
    /**
     * Create Payment Transaction
     * @param requestBody
     * @returns OrderPaymentTransactionResponse Successful Response
     * @throws ApiError
     */
    public static createPaymentTransactionOrderPaymentsPost(
        requestBody: OrderPaymentTransactionCreate,
    ): CancelablePromise<OrderPaymentTransactionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/order/payments/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Payment Transactions
     * @param orderId
     * @returns OrderPaymentTransactionResponse Successful Response
     * @throws ApiError
     */
    public static listPaymentTransactionsOrderPaymentsTransactionsOrderIdGet(
        orderId: number,
    ): CancelablePromise<Array<OrderPaymentTransactionResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/order/payments/transactions/{order_id}',
            path: {
                'order_id': orderId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Payment Transaction
     * @param id
     * @returns OrderPaymentTransactionResponse Successful Response
     * @throws ApiError
     */
    public static getPaymentTransactionOrderPaymentsIdGet(
        id: number,
    ): CancelablePromise<OrderPaymentTransactionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/order/payments/{id}',
            path: {
                'id': id,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Payment Transaction
     * @param id
     * @param requestBody
     * @returns OrderPaymentTransactionResponse Successful Response
     * @throws ApiError
     */
    public static updatePaymentTransactionOrderPaymentsIdPut(
        id: number,
        requestBody: OrderPaymentTransactionUpdate,
    ): CancelablePromise<OrderPaymentTransactionResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/order/payments/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
